import { render, staticRenderFns } from "./GridNav.vue?vue&type=template&id=4b5a5e34&scoped=true&"
import script from "./GridNav.vue?vue&type=script&lang=ts&"
export * from "./GridNav.vue?vue&type=script&lang=ts&"
import style0 from "./GridNav.vue?vue&type=style&index=0&id=4b5a5e34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5a5e34",
  null
  
)

export default component.exports